import Sections from "components/Contractors/sections";
import {ReadOnlyTextField} from "components/Shared/ReadOnlyTextField";
import {formatPrice} from "components/Contractors/Details/utils";
import {DetailsColumn} from "components/Shared/CrudComponents";
import React from "react";
import {useTranslation} from "react-i18next";

const financialDetailsDefinitions = [
    {
        fieldName: 'balanceIncome',
        amountLabel: 'contractor.form.financeDetails.balanceIncome',
    },
    {
        fieldName: 'balanceCost',
        amountLabel: 'contractor.form.financeDetails.balanceCost',
    },
    {
        fieldName: 'overdueIncome',
        amountLabel: 'contractor.form.financeDetails.overdueIncome',
    },
    {
        fieldName: 'overdueCost',
        amountLabel: 'contractor.form.financeDetails.overdueCost',
    },
    {
        fieldName: 'income',
        amountLabel: 'contractor.form.financeDetails.income',
    },
    {
        fieldName: 'cost',
        amountLabel: 'contractor.form.financeDetails.cost',
    },
    {
        fieldName: 'paidIncome',
        amountLabel: 'contractor.form.financeDetails.paidIncome',
    },
    {
        fieldName: 'paidCost',
        amountLabel: 'contractor.form.financeDetails.paidCost',
    },
    {
        fieldName: 'balanceOfInvolvement',
        amountLabel: 'contractor.form.financeDetails.balanceOfInvolvement',
    }
]


export const ContractorFinanceDetails = ({contractorBalance, ...columnProps}) => {
    const {t} = useTranslation()

    return (
        <DetailsColumn section={Sections.FinanceDetails} {...columnProps}>
            {
                financialDetailsDefinitions.map(row => (
                    <ReadOnlyTextField
                        key={row.fieldName}
                        label={`${t(row.amountLabel)}`}
                        value={contractorBalance.balance ? formatPrice(contractorBalance.balance[row.fieldName]) : ''}
                    />
                ))
            }
        </DetailsColumn>
    )
}